<mat-card class="h-full">
  <mat-card-header class="mb-4">
    <mat-card-title>{{ title() }}</mat-card-title>
    <mat-card-subtitle>{{ subtitle() }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (user(); as currentUser) {
      <dl class="grid gap-3 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 text-sm">
        <div>
          <dt class="font-semibold">First name</dt>
          <dd>{{ currentUser.firstName }}</dd>
        </div>
        <div>
          <dt class="font-semibold">Last name</dt>
          <dd>{{ currentUser.lastName }}</dd>
        </div>
        <div>
          <dt class="font-semibold">Email</dt>
          <dd>{{ currentUser.email }}</dd>
        </div>
        <div>
          <dt class="font-semibold">Portal</dt>
          <dd>{{ currentUser.portal }}</dd>
        </div>
        <div>
          <dt class="font-semibold">User role</dt>
          <dd>{{ currentUser.userRole }}</dd>
        </div>
        <div>
          <dt class="font-semibold">Client</dt>
          <dd>{{ currentUser.client || 'No client' }}</dd>
        </div>
      </dl>
    } @else {
      <p class="text-sm">No user data loaded.</p>
    }
  </mat-card-content>
</mat-card>
